const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? ''

/**
 * 카카오 커스텀 템플릿의 링크는 '도메인/v2/${url}' 구조라 템플릿이 basePath(/v2)를 앞에 붙인다.
 * 따라서 절대 URL에서 도메인과 basePath(/v2)를 제거한 경로(쿼리 포함)를 반환해 /v2 중복을 막는다.
 * basePath 밖 경로(예: /public/...)는 basePath로 시작하지 않으므로 그대로 둔다.
 * 예) https://service.mycle.co.kr/v2/report/monthly-maintenance?share=x → report/monthly-maintenance?share=x
 */
export const buildKakaoLinkPath = (absoluteUrl: string): string => {
  const { pathname } = new URL(absoluteUrl)
  const pathWithQuery = absoluteUrl.substring(absoluteUrl.indexOf(pathname))
  const withoutBasePath =
    BASE_PATH && pathWithQuery.startsWith(BASE_PATH)
      ? pathWithQuery.slice(BASE_PATH.length)
      : pathWithQuery
  return withoutBasePath.replace(/^\//, '')
}

/**
 * 카카오 공유 커스텀 템플릿 ID를 환경별로 선택한다.
 * - dev만 비운영(DEV), stage·운영은 운영(PROD) 템플릿을 사용한다.
 */
export const resolveKakaoTemplateId = (templateId: {
  DEV: number
  PROD: number
}): number =>
  process.env.NEXT_PUBLIC_APP_ENV === 'development'
    ? templateId.DEV
    : templateId.PROD
